import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {DatePipe} from '@angular/common';
import {BsModalService} from 'ngx-bootstrap';
import {OlderMonthSelectorComponent} from './older-month-selector/older-month-selector.component';

@Component({
    selector: 'app-month-selector',
    templateUrl: './month-selector.component.html',
    styleUrls: ['./month-selector.component.scss']
})
export class MonthSelectorComponent implements OnInit {

    constructor(
        private date: DatePipe,
        private bsModal: BsModalService
    ) {
    }

    periods: Array<string> = null;
    older_periods: Array<string> = [];


    @Input()
    range: number = 6;

    @Input()
    public offset: number = -1;

    @Input()
    public default: number = 0;

    @Output()
    public change = new EventEmitter();

    @Output()
    public selected: string = null;

    @Input()
    public classStyle: string = 'default';

    private nextPeriod: string;
    custom = 'Cũ hơn';
    customMonth = '';
  ngOnInit() {

    let now = new Date();

    this.nextPeriod = this.date.transform(now, "MM-yyyy");

    now.setMonth(now.getMonth() + this.offset + 1);
    this.periods = [];

    let older = now.getMonth() + 36;

    for (let i = 0; i < older; i++) {
      now.setDate(0);
      if (i < this.range) {
        this.periods.push(this.date.transform(now, "MM-yyyy"));
      } else {
        this.older_periods.push(this.date.transform(now, "MM-yyyy"));
      }
    }
    this.periods.push(this.custom);
    this.select(this.periods[this.default]);

  }

    public select(period) {

        if(period == this.custom){
            this.bsModal.show(OlderMonthSelectorComponent, {
                class: 'modal-md',
                initialState:{
                    data: this.older_periods
                }
            }).content.change.subscribe( rs => {
                this.selected = this.custom;
                this.change.emit(rs);
                this.customMonth = rs;
            })
        }else{
            this.selected = period;
            this.change.emit(period);
        }
    }

    public display(period) {
        return period == this.nextPeriod ? 'THÁNG NÀY' : period;
    }
}
